module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "game-warp"
  }, [_c('div', {
    staticClass: "game-box row"
  }, [_c('div', {
    staticClass: "game-box-left column",
    class: {
      'current-user': _vm.user2.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user2.id,
      "data-email": _vm.user2.email,
      "data-username": _vm.user2.username,
      "data-realname": _vm.user2.realname,
      "data-lineStatus": _vm.user2.lineStatus,
      "data-isSkip": _vm.user2.isSkip,
      "data-sort": _vm.user2.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user2.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center"
  }, [_vm._l((_vm.user2.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 2, _vm.user2.cards, 'user2')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user2.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card2 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user2.isSkip),
      expression: "user2.isSkip"
    }],
    staticClass: "mask left-mask",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user2.username, _vm.user2.id, 2)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip"
  }, [_vm._v("スキップ解除")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-min column column-center row-flex"
  }, [_c('div', {
    staticClass: "game-cards-box row-flex row"
  }, [_c('div', {
    staticClass: "left column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location2",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user2.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardl",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            2,
            $event,
            _vm.user2.discard,
            'user2'
          )
        }
      }
    })], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "min column row-flex"
  }, [_c('div', {
    staticClass: "min-cards-box row-flex column column-center row-center",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "calc(var(--vp) * 8.765 * 1.1)",
      "height": "calc(var(--vp) * 10.925 * 1.1)"
    }
  }, [_c('div', {
    staticClass: "rest"
  }, [_vm._v("残り枚数: " + _vm._s(_vm.cards.length) + "枚")]), _vm._v(" "), _c('div', {
    ref: "gamecardslists",
    staticClass: "cards-lists"
  }, _vm._l((_vm.cards), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "card-box",
      class: 'card' + item.id,
      style: (item.style)
    }, [_c('el-image', {
      staticClass: "card",
      attrs: {
        "src": _vm.cardsBack,
        "fit": "contain"
      },
      on: {
        "click": function($event) {
          return _vm.extractCard(item, index)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.extracting) ? _c('div', {
    staticClass: "card-top"
  }, [(_vm.info.isPublic || _vm.mode == 'watch' || _vm.user1.sort == _vm.playUser) ? _c('el-image', {
    staticClass: "card cards",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.extractCardInfo.url,
      "fit": "contain"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.info.isPublic && _vm.mode != 'watch' && _vm.user1.sort != _vm.playUser) ? _c('el-image', {
    staticClass: "card cards",
    attrs: {
      "id": _vm.extractCardInfo.id,
      "src": _vm.cardsBack,
      "fit": "contain"
    }
  }) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "min-bottom column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists cards-lists-mine",
    on: {
      "click": function($event) {
        return _vm.discardCard(1, $event)
      }
    }
  }, [_c('div', {
    ref: "location1",
    staticClass: "cards-scroll row column-center",
    style: ({
      width: _vm.scrollWidth
    }),
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user1.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "hor-cardd"
    }, [_c('el-image', {
      staticClass: "card cardm",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            1,
            $event,
            _vm.user1.discard,
            'user1'
          )
        }
      }
    })], 1)
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "right column column-center row-center"
  }, [_c('div', {
    staticClass: "cards-lists"
  }, [_c('div', {
    ref: "location3",
    staticClass: "cards-scroll column column-center",
    on: {
      "mousedown": function($event) {
        return _vm.dragscroll($event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchStart($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchMove($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        return _vm.dragscrollTouchEnd($event)
      }
    }
  }, _vm._l((_vm.user3.discard), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ver-cardd"
    }, [_c('el-image', {
      staticClass: "card cardr",
      class: {
        'active': item.checked == true, 'last-discard': item.id == _vm.lastDiscardNum
      },
      attrs: {
        "src": item.url,
        "fit": "fill"
      },
      on: {
        "mouseover": function($event) {
          return _vm.discard_hover($event)
        },
        "mouseout": function($event) {
          return _vm.discard_leave($event)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.extractCardFromDiscards(
            item,
            index,
            3,
            $event,
            _vm.user3.discard,
            'user3'
          )
        }
      }
    })], 1)
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "game-box-right column",
    class: {
      'current-user': _vm.user3.sort == _vm.playUser
    },
    attrs: {
      "data-id": _vm.user3.id,
      "data-email": _vm.user3.email,
      "data-username": _vm.user3.username,
      "data-realname": _vm.user3.realname,
      "data-lineStatus": _vm.user3.lineStatus,
      "data-isSkip": _vm.user3.isSkip,
      "data-sort": _vm.user3.sort
    }
  }, [_c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.user3.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-cards-box column column-center",
    staticStyle: {
      "flex-direction": "column-reverse"
    }
  }, [_vm._l((_vm.user3.cards), function(item, index) {
    return (_vm.info.isPublic || _vm.mode == 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card3 cardh",
      class: item.checked == true ? 'active' : '',
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeOtherCard(item, index, $event, 3, _vm.user3.cards, 'user3')
        }
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.user3.cards), function(item, index) {
    return (!_vm.info.isPublic && _vm.mode != 'watch') ? _c('div', {
      key: index,
      staticClass: "ver-cardu"
    }, [_c('el-image', {
      staticClass: "card3 cardh",
      attrs: {
        "src": _vm.cardsBack,
        "data-id": item.id,
        "fit": "fill"
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user3.isSkip),
      expression: "user3.isSkip"
    }],
    staticClass: "mask right-mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user3.username, _vm.user3.id, 3)
      }
    }
  }, [_vm._v("\n          スキップ解除\n        ")]) : _vm._e(), _vm._v("\n        スキップ状態\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "game-user-self row"
  }, [_c('div', {
    staticClass: "myself"
  }, [_vm._v(_vm._s(_vm.user1.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "user-box",
    attrs: {
      "data-id": _vm.user1.id,
      "data-email": _vm.user1.email,
      "data-username": _vm.user1.username,
      "data-realname": _vm.user1.realname,
      "data-lineStatus": _vm.user1.lineStatus,
      "data-isSkip": _vm.user1.isSkip,
      "data-sort": _vm.user1.sort
    }
  }, [_c('div', {
    staticClass: "user-cards-box row row-center column-center",
    class: {
      'current-user': _vm.user1.sort == _vm.playUser
    }
  }, [_vm._l((_vm.user1.cards), function(item, index) {
    return _c('el-image', {
      key: index,
      staticClass: "card cards",
      class: {
        cardchecked: _vm.mode == 'play'
      },
      attrs: {
        "src": item.url,
        "data-id": item.id,
        "fit": "fill"
      },
      on: {
        "click": function($event) {
          return _vm.changeSelfCard(item, index, $event, 1)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user1.isSkip),
      expression: "user1.isSkip"
    }],
    staticClass: "mask"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "release-skip",
    on: {
      "click": function($event) {
        return _vm.cancelSkip(_vm.user1.username, _vm.user1.id, 1)
      }
    }
  }, [_vm._v("\n            スキップ解除\n          ")]) : _vm._e(), _vm._v("\n          スキップ状態\n        ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "room-info row-flex column column-center"
  }, [(_vm.mode == 'play' || _vm.isHomewer) ? _c('div', {
    staticClass: "btns-box row"
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doTimeOut()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/time-out.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode != 'watch'),
      expression: "mode != 'watch'"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSelfSkip()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px",
      "color": "#63aeb0",
      "font-weight": "bold"
    }
  }, [_vm._v("Pass")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'watch' && _vm.isHomewer),
      expression: "mode == 'watch' && isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goPage('/')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-arrow-left"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHomewer),
      expression: "isHomewer"
    }],
    staticClass: "item row-flex column column-center row-center",
    on: {
      "click": function($event) {
        return _vm.doSet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/setting.png")
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.mode == 'watch') ? _c('div', {
    staticClass: "item countdown spectator",
    staticStyle: {
      "flex-direction": "row",
      "justify-content": "space-around"
    }
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v("観戦者")]), _vm._v(" "), (_vm.mode == 'watch' && _vm.isHomewer) ? _c('div', {
    staticClass: "watch-number peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item countdown"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.userTimes)), _c('span', [_vm._v("s")])]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("時間")])]), _vm._v(" "), _c('div', {
    staticClass: "item times"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s(_vm.gameTimes.str))]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("トータル時間")])]), _vm._v(" "), (!(_vm.mode == 'watch' && _vm.isHomewer)) ? _c('div', {
    staticClass: "item peopleNumber"
  }, [_c('div', {
    staticClass: "counts"
  }, [_vm._v(_vm._s((_vm.totalPerson * 1 - _vm.gemePeople * 1) < 0 ? 0 : _vm.totalPerson * 1 - _vm.gemePeople * 1) + "人")]), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_vm._v("観戦者数")])]) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "設定",
      "top": "250px",
      "visible": _vm.dialogSettingVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.toFinish()
      }
    }
  }, [_vm._v("終了")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "一時停止",
      "top": "250px",
      "visible": _vm.dialogPauseVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogPauseVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.isHomewer) ? _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPause()
      }
    }
  }, [_vm._v("停止する")]) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "show-close": false,
      "title": "一時停止中",
      "top": "250px",
      "visible": _vm.dialogPauseVisible && _vm.cards.length > 0,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogPauseVisible && _vm.cards, "length > 0", $event)
      }
    }
  }, [(_vm.isHomewer) ? _c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reStart()
      }
    }
  }, [_vm._v("ゲームを再開する")])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "close-on-click-modal": false,
      "title": "ゲームを終了しますか？",
      "top": "250px",
      "visible": _vm.dialogFinishVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFinishVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "finish-btn",
    on: {
      "click": function($event) {
        return _vm.doFinish()
      }
    }
  }, [_vm._v("終了する")]), _vm._v(" "), _c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        return _vm.toGame()
      }
    }
  }, [_vm._v("続ける")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "setting-box",
    attrs: {
      "title": "Pass",
      "top": "250px",
      "visible": _vm.dialogSkipVisiblePre,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisiblePre = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-footer btns-box column row-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "skip-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doPass()
      }
    }
  }, [_vm._v("パスする")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "skip-box",
    attrs: {
      "title": "スキップさせるユーザーを選択",
      "top": "250px",
      "visible": _vm.dialogSkipVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSkipVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "personnel-box row"
  }, _vm._l((_vm.users2), function(item, index) {
    return (!item.isHomewer) ? _c('div', {
      key: index,
      staticClass: "card column column-center row-center",
      class: {
        checked: item.checked
      },
      on: {
        "click": function($event) {
          return _vm.checkUser(item, index, item.checked)
        }
      }
    }, [_c('div', {
      staticClass: "text-box"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(item.tag))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer btns-box",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "save-btn",
    on: {
      "click": function($event) {
        return _vm.doSkip()
      }
    }
  }, [_vm._v("スキップ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1f65e6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/game/Index3.vue
// module id = 900
// module chunks = 1